module.exports = __webpack_public_path__ + "static/media/p3.f69a2d2f.png";